import React from "react";

interface Props {
  width?: number;
  height?: number;
  color?: string;
}

const IconDefaultXMark = ({
  width = 24,
  height = 24,
  color = "black",
}: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.4419 7.44194C17.686 7.19786 17.686 6.80214 17.4419 6.55806C17.1979 6.31398 16.8021 6.31398 16.5581 6.55806L12 11.1161L7.44194 6.55806C7.19786 6.31398 6.80214 6.31398 6.55806 6.55806C6.31398 6.80214 6.31398 7.19786 6.55806 7.44194L11.1161 12L6.55806 16.5581C6.31398 16.8021 6.31398 17.1979 6.55806 17.4419C6.80214 17.686 7.19786 17.686 7.44194 17.4419L12 12.8839L16.5581 17.4419C16.8021 17.686 17.1979 17.686 17.4419 17.4419C17.686 17.1979 17.686 16.8021 17.4419 16.5581L12.8839 12L17.4419 7.44194Z"
        fill={color}
      />
    </svg>
  );
};

export default IconDefaultXMark;
